import { css } from "@emotion/css"
import { Fragment } from "react"

import Anchor from "@p-ban/common/src/components/html/Anchor"
import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import { commaFormat } from "@p-ban/common/src/utils/NumberUtils"

import useLoginStatusQuery from "../../../api/login/useLoginStatusQuery"
import useAchievementQuery from "../../../api/staticSite/useAchievementQuery"
import HeaderNav from "./HeaderNav/HeaderNav"
import Search from "./Search/Search"

import logo from "./logo.png"

const Header = () => {
  const { numberOfTradingCompanies, deliveryDateComplianceRate } = useAchievementQuery() ?? {}
  const { isLoggedIn = false } = useLoginStatusQuery()

  const links = [
    { text: "初めてのお客様", href: "/others/about_pban.html" },
    ...(isLoggedIn
      ? [
          { text: "マイページ", href: "/kiban/com/csComTop.do" },
          { text: "ログアウト", href: "/kiban/csComLogout.do" },
        ]
      : [
          { text: "新規登録", href: "/kiban/signup" },
          { text: "ログイン", href: "/kiban/csComLogin.do" },
        ]),
  ]

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <h1 className={styles.logo}>
          <Anchor href="/" newTab>
            <Image src={logo} alt="P板.com" />
          </Anchor>
        </h1>
        <div className={styles.wrapper}>
          <Anchor href="/information/transaction.html" className={styles.appealLink}>
            信頼の取引実績
            <Spacer size={5} />
            <span className={styles.appeal}>
              {numberOfTradingCompanies !== undefined && commaFormat(numberOfTradingCompanies)}社
            </span>
          </Anchor>
          <Spacer size={10} />
          <Anchor href="/information/keep_observance.html" className={styles.appealLink}>
            現在の納期遵守率
            <Spacer size={10} />
            <span className={styles.appeal}>{deliveryDateComplianceRate}％</span>
          </Anchor>
          <Spacer size={16} />
          <Search />
          {links.map((link) => (
            <Fragment key={link.text}>
              <span className={styles.divider} />
              <Anchor href={link.href} className={styles.link}>
                {link.text}
              </Anchor>
            </Fragment>
          ))}
        </div>
      </div>
      <HeaderNav />
    </header>
  )
}

export default Header

const styles = {
  header: css`
    position: sticky;
    top: -83px;
    z-index: 1;
  `,
  container: css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    max-width: 1400px;
    padding: 0 30px;
    margin: 0 auto;
  `,
  logo: css`
    padding: 20px 0;
    > a {
      display: block;
      height: 43px;
    }
  `,
  wrapper: css`
    display: flex;
    align-items: center;
    height: 19px;
    margin-top: auto;
    margin-bottom: 25px;
  `,
  appealLink: css`
    display: flex;
    align-items: baseline;
    font-size: 12px;
    line-height: 1;
    color: #666;
  `,
  appeal: css`
    min-width: 76px;
    font-size: 16px;
    font-weight: bold;
    color: #f7a500;
    text-align: right;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  `,
  divider: css`
    height: 17px;
    margin: 0px 12px;
    border-left: 1px solid #ccc;
  `,
  link: css`
    font-size: 15px;
    color: #666666;
    &:hover {
      text-decoration: underline;
    }
  `,
}
